export function formatDistanceInMiles(
  distanceInMiles: number,
  unitDisplay: "long" | "short" = "short"
) {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "unit",
    unit: "mile",
    unitDisplay,
    maximumFractionDigits: 0,
  });
  return formatter.format(distanceInMiles);
}

export function formatDistanceInMilesOrMeters(
  distanceInMiles: number,
  unitDisplay: "long" | "short" = "short"
) {
  if (distanceInMiles >= 1 || distanceInMiles === 0) {
    return formatDistanceInMiles(distanceInMiles, unitDisplay);
  }

  const metersInOneMile = 1609.344;
  const formatter = new Intl.NumberFormat("en-US", {
    style: "unit",
    unit: "meter",
    unitDisplay,
    maximumFractionDigits: 0,
  });
  return formatter.format(distanceInMiles * metersInOneMile);
}
